export default {"id":"33451e8c","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}